import ScrollViewImplementation from './implementation/ScrollViewImplementation';
var ScrollViewComponent = ScrollViewImplementation;
export default ScrollViewComponent;
//# sourceMappingURL=ScrollViewComponent.js.map